import { FORMAT_DATE_DEFAULT, FORMAT_TIME_DEFAULT } from "@/common/datetime/TimeFunction";
import { BuildRCAttribute } from "@/common/function/RCAttribute";
import Canvas from "@/components/ui/Canvas";
import { ICanvasProps } from "@/components/ui/Canvas/Models";
import {
  RenderIconCalendar,
  RenderIconDismiss,
  RenderIconInfo,
  // RenderIconStar,
  SelectedResourceIcon,
} from "@/components/ui/Icons/IconsCustom";
import ResourceItem from "@/components/ui/ResourceItem";
import TimeLine from "@/components/ui/TimeLine";
import { buildEventList } from "@/components/ui/TimeLine/constains/FunctionTimeline";
import { RootState } from "@/redux";
import { IOrganizationStore } from "@/redux/slices/organizations/OrganizationModel";
import { IResourceStore } from "@/redux/slices/resources/ResourceReducerModel";
import { ISettingStore } from "@/redux/slices/settings/SettingModel";
import { ResourceInfo } from "@/services/resource-service/entity/ResourceEntity";
import Availability from "@/view/addin/components/availability";
import IconPermission from "@/view/addin/components/icon-permission";
import TentativePermission from "@/view/addin/components/icon-permission/TentativeIcon";
import ResourceCalendar from "@/view/addin/components/resource-calendar";
import { IRefComponentType } from "@/view/addin/components/resource-calendar/Models";
import ResourceDetail from "@/view/addin/components/resource-detail";
import { IRefComponentDetailType } from "@/view/addin/components/resource-detail/Models";
// import { ScrollDismissTooltip } from "@fluentui/react-tooltip";
import { RefObject, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { IResourceSelectedProps } from "./ResourceSelectedModel";
import { HeaderTitleWrapper, ResourceInfoWrapper, ResourceSelectedBaseWrapper } from "./Styles";
import Nodata from "@/components/ui/Nodata";
import { sortRs } from "@/common/function/ArrayFunction";
import ScrollDismissTooltip from "@/components/ui/Tooltip";

const ResourceSelected = (props: IResourceSelectedProps) => {
  const { t } = useTranslation();
  const refCalendar: RefObject<IRefComponentType | null> = useRef(null);
  const refDetail: RefObject<IRefComponentDetailType | null> = useRef(null);
  const resourceStore: IResourceStore = useSelector((state: RootState) => state.resources) as IResourceStore;

  const orgStore: IOrganizationStore = useSelector((state: RootState) => state.orgInfo) as IOrganizationStore;

  const settingStore: ISettingStore = useSelector((state: RootState) => state.settingInfo) as ISettingStore;
  const dateFormat = settingStore?.dateTimeFormat.dateTimeSeparator;
  const timeFormat = settingStore?.dateTimeFormat.timeFormat;
  const firstDayOfWeek = Number(settingStore?.dateTimeFormat.firstDayOfWeek || "0");

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [timeSlider, setTimeSlider] = useState(orgStore.outlookInfo?.displayStartTime || new Date());

  const resources: ResourceInfo[] | null = sortRs(resourceStore?.selectedResource || []);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    setIsOpen(!!resourceStore.selectedResource?.length);
    //saveDataOnSessionOutlook();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(resourceStore.selectedResource)]);

  useEffect(() => {
    setTimeSlider(orgStore.outlookInfo?.displayStartTime || new Date());
  }, [orgStore.outlookInfo?.displayStartTime]);

  const onOpenResourceDetail = (ev: React.MouseEvent<HTMLImageElement>, resourceInfo: ResourceInfo) => {
    ev.stopPropagation();
    if (refDetail?.current?.onOpenResourceDetail) {
      refDetail?.current?.onOpenResourceDetail(resourceInfo);
    }
  };

  const args: ICanvasProps = {
    headerTitle: (
      <HeaderTitleWrapper className="HeaderTitleWrapper">
        <SelectedResourceIcon theme={settingStore.theme} />

        <span>
          {t("Resource Selected")} ({resources?.length})
        </span>
      </HeaderTitleWrapper>
    ),
    isStickHeader: false,
    isOpen: isOpen,
  };

  const renderHeaderButtons = (resource: ResourceInfo): JSX.Element => {
    return (
      <>
        {resource.permission.meetingDeclines?.length ? (
          <IconPermission
            permission={resource.permission}
            exchangeProperty={resource.exchangeProperty}
            isRecurring={orgStore.outlookInfo?.isRecurringMaster}
            quantityMeetingInfo={orgStore.outlookInfo?.occurrences?.length}
          />
        ) : null}
        {resource.permission.isTentative ? <TentativePermission permission={resource.permission} theme={settingStore.theme || undefined} /> : null}
        <div>
          <ScrollDismissTooltip content={t("Calendar")} relationship="label">
            <div onClick={(ev: React.MouseEvent<HTMLImageElement>) => onOpenCalendar(ev, resource)} {...BuildRCAttribute(`resource_item.${resource.name}.calendar`)}>
              <RenderIconCalendar theme={settingStore.theme} />
            </div>
          </ScrollDismissTooltip>
        </div>
        <ScrollDismissTooltip content={t("View Details")} relationship="label">
          <div onClick={(ev: React.MouseEvent<HTMLImageElement>) => onOpenResourceDetail(ev, resource)} {...BuildRCAttribute(`resource_item.${resource.name}.detail`)}>
            <RenderIconInfo theme={settingStore.theme} />
          </div>
        </ScrollDismissTooltip>
        {/*  <ScrollDismissTooltip  content={t("Add to My Favorites")} relationship="label">
          <div
            {...BuildRCAttribute(`resource_item.${resource.name}.favorites`)}
          >
            <RenderIconStar theme={settingStore.theme} />
          </div>
        </ScrollDismissTooltip> */}
        <ScrollDismissTooltip content={t("Remove")} relationship="label">
          <div onClick={() => onDeleteSelectedResource(resource)} {...BuildRCAttribute(`resource_item.${resource.name}.remove`)}>
            <RenderIconDismiss theme={settingStore.theme} />
          </div>
        </ScrollDismissTooltip>
      </>
    );
  };

  const onDeleteSelectedResource = (resource: ResourceInfo): void => {
    if (props.deleteSelectResource) {
      props.deleteSelectResource(resource);
    }
  };

  const onOpenCalendar = (ev: React.MouseEvent<HTMLImageElement>, resourceInfo: ResourceInfo) => {
    ev.stopPropagation();
    if (refCalendar?.current?.onOpenResourceCalendar) {
      refCalendar?.current?.onOpenResourceCalendar(resourceInfo, orgStore.outlookInfo?.start || null);
    }
  };
  const [maxHeight, setMaxHeight] = useState<number>(450);
  const [isMounted, setIsMounted] = useState(false);
  const scrollableRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    setIsMounted(true);

    const calculateMaxHeight = () => {
      if (scrollableRef.current) {
        const windowHeight = window.innerHeight;
        const scrollableTop = scrollableRef.current.getBoundingClientRect().top;
        const bottomPadding = 20;
        const newMaxHeight = windowHeight - scrollableTop - bottomPadding;
        setMaxHeight(Math.max(newMaxHeight, 200));
      }
    };

    let retryInterval: any | null = null;

    const setupCalculation = () => {
      if (scrollableRef.current) {
        calculateMaxHeight();
        window.addEventListener("resize", calculateMaxHeight);
        if (retryInterval) {
          clearInterval(retryInterval);
        }
      } else {
        retryInterval = setInterval(setupCalculation, 100); // Retry every 100ms
      }
    };

    if (isMounted) {
      setupCalculation();
    }

    return () => {
      window.removeEventListener("resize", calculateMaxHeight);
      if (retryInterval) {
        clearInterval(retryInterval);
      }
    };
  }, [isMounted]);
  return (
    <>
      <ResourceSelectedBaseWrapper className="ResourceSelectedBaseWrapper">
        <Canvas {...args} theme={settingStore.theme || undefined} rcName="resource_selected">
          <div className="scrollable-content" ref={scrollableRef} style={{ maxHeight: `${maxHeight}px`, overflowY: "auto" }}>
            {resources?.length ? (
              resources?.map((resource: ResourceInfo) => {
                return (
                  <ResourceInfoWrapper key={resource.guid} className="ResourceInfoWrapper">
                    <ResourceItem
                      isSelected={false}
                      id={resource.guid}
                      avatar=""
                      name={`${resource.displayName || resource.name}`}
                      isShowClosingIcon={true}
                      model={resource}
                      leftBorderStyle={orgStore.outlookInfo?.isRecurringMaster ? resource.calculateBorderRecurring(orgStore.outlookInfo?.occurrences?.length || 0) : resource.calculateBorder}
                      isShowTimeLine={!orgStore.outlookInfo?.isRecurringMaster}
                      headerButtons={renderHeaderButtons(resource)}
                      theme={settingStore.theme || undefined}
                      availabilityBox={<Availability resource={resource} meetingInfos={orgStore.outlookInfo?.occurrences} dateFormat={settingStore?.dateTimeFormat?.dateTimeSeparator} />}
                      timeLineElements={
                        <TimeLine
                          timeSlider={timeSlider}
                          startTimeSelected={orgStore.outlookInfo?.displayStartTime || new Date()}
                          endTimeSelected={orgStore.outlookInfo?.displayEndTime || new Date()}
                          localizer="en-US"
                          isNoInformation={true}
                          dateTimeFormat={{
                            dateFormat: dateFormat || FORMAT_DATE_DEFAULT,
                            timeFormat: timeFormat || FORMAT_TIME_DEFAULT,
                          }}
                          events={buildEventList(timeSlider, resource, {
                            startTime: new Date(orgStore.outlookInfo?.displayStartTime || ""),
                            endTime: new Date(orgStore.outlookInfo?.displayEndTime || ""),
                          })}
                          exchangePropertyResource={resource?.exchangeProperty}
                        />
                      }
                    />
                  </ResourceInfoWrapper>
                );
              })
            ) : (
              <div className="nodata">
                <Nodata />
              </div>
            )}
          </div>
        </Canvas>
      </ResourceSelectedBaseWrapper>
      <ResourceCalendar ref={refCalendar} dateFormat={dateFormat} timeFormat={timeFormat} firstDayOfWeek={firstDayOfWeek} />
      <ResourceDetail ref={refDetail} />
    </>
  );
};

export default ResourceSelected;
